import { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { FormattedMessage, injectIntl, intlShape } from 'react-intl'
import { findIndex, get } from 'lodash'
import PriceConverter from '../helpers/PriceConverter'
import PromotionLabel from '../helpers/PromotionLabel'
import ConvertMetersToFeets from '../helpers/ConvertMetersToFeets'
import { getTextFromInfo, serializeData, isLastMinuteBooking } from '../../utils'
import { createUrl } from '../../localized-urls'
import messages from '../../messages'
import { generateGuestsText } from '../forms/GuestPicker'
import ResortPricingRowUnavailable from './ResortPricingRowUnavailable'
import { setResortInclusionsData, showResortInclusions } from '../../actions/main-actions'

export const mealPlanIcon = function(mealPlan) {
  let icon = 'font-icons '

  if(mealPlan >= 50) {
    icon += 'icon-allincl prm'
  } else if(mealPlan === 20) {
    icon += 'icon-breakfast prm'
  } else if(mealPlan > 20 && mealPlan < 50) {
    icon += 'icon-halfboard prm'
  }

  return icon
}

const generatePricingType = function(isFixedPackage, roomParams, room) {
  if((roomParams.divers && !roomParams.students && !roomParams.nonDivers) ||
    (roomParams.divers && !roomParams.students && roomParams.nonDivers)) {
    if(room.packageDiveKind === 30) {
      return <FormattedMessage
        id='unlimited_shore_dives_included'
        defaultMessage='including unlimited shore dives' />
    } else {
      return <FormattedMessage
        id='divers_or_non-divers_only_pricing_type'
        values={{
          duration: room.nights,
          divesAmount: room.divesAmount * roomParams.divers,
          diveType: !isFixedPackage ? getTextFromInfo(room.diveType, 'shop', 'DIVE_TYPE').toLowerCase() : '',
        }}
        defaultMessage='{ duration, plural, one {# night} other {# nights}} incl. {divesAmount} {diveType} dives' />
    }
  } else if(!roomParams.divers && roomParams.students) {
    return <FormattedMessage
      id='students_only_pricing_type'
      values={{
        duration: room.nights,
      }}
      defaultMessage='{ duration, plural, one {# night} other {# nights}} incl. diving courses' />
  } else {
    if(room.packageDiveKind === 30) {
      return <FormattedMessage
        id='unlimited_shore_dives_and_courses_included'
        defaultMessage='including unlimited shore dives and diving courses' />
    } else {
      return <FormattedMessage
        id='divers_or_non-divers_or_students_only_pricing_type'
        values={{
          duration: room.nights,
          divesAmount: room.divesAmount * roomParams.divers,
          diveType: !isFixedPackage ? getTextFromInfo(room.diveType, 'shop', 'DIVE_TYPE').toLowerCase() : '',
        }}
        defaultMessage='{ duration, plural, one {# night} other {# nights}} incl. {divesAmount} {diveType} dives and diving courses' />
    }
  }
}
class ResortPricingRow extends Component {
  constructor(props) {
    super(props)

    this.state = {
      mealPlan: props.room.rates.length && props.room.rates[0].mealPlan,
    }
  }

  checkoutDrUrl = (rate, room) => {
    const params = serializeData({
      rate: rate.id,
      room: room.id,
      mealPlan: rate.mealPlan,
      packages: rate.packages,
    })

    return createUrl(
      'checkout_dr',
      {
        slug: this.props.slug,
        location: this.props.countrySlug,
      },
      '?' + params,
    )
  }

  mobileCollapseHandler = (type) => {
    this.setState({
      [type]: !this.state[type],
    })
  }

  showWhatsIncluded = (room, diveType) => {
    this.props.dispatch(setResortInclusionsData({
      slug: this.props.slug,
      currency: room.currency,
      queryParams: {
        ...this.props.filters,
        rate: room.rates && room.rates[0].id,
        packages: room.rates && room.rates[0].packages,
      },
      room,
      diveType,
      insurance: this.props.insurance,
      duration: this.props.duration,
      isPackage: this.props.isFixedPackage,
      mealPlanDescription: this.props.mealPlans[this.state.mealPlan],
    }))
    this.props.dispatch(showResortInclusions(true))
  }

  render() {
    const { room, isFixedPackage, intl, roomParams, insurance } = this.props
    const pricingObject = room.rates[findIndex(room.rates, { mealPlan: this.state.mealPlan })]
    const totalGuests = roomParams.divers + roomParams.students + roomParams.nonDivers
    const diveType = getTextFromInfo(room.diveType, 'shop', 'DIVE_TYPE').toLowerCase()
    const insuranceTooltip = intl.formatMessage(messages.diveInsuranceDescription, { price: get(insurance, 'limitPrice', 'n/a') })

    if(!pricingObject) {
      return <ResortPricingRowUnavailable
        room={room}
        openRoomPopup={this.props.openRoomPopup}
        key={room.id}
      />
    }
    return (
      <div className='resort-pricing-row' id={`room_${room.id}`}>
        <div className='resort-pricing__rooms'>
          <h4 className='room-name'>{ room.title }</h4>
          <div className='room-info'>
            <div className='room-image' onClick={() => this.props.openRoomPopup(room)} style={{ backgroundImage: `url(${room.images[0].thumbnails.FeaturedDealsSmallDesktop})` }}>
              <div className='custom-paging'>1 / { room.images.length }</div>
            </div>
            <div className='room-info-wrapper'>
              <ul className='room-info-list'>
                <li>
                  <i className='font-icons people-icon' />
                  <FormattedMessage id='people_max'
                    values={{
                      maxOccupancy: room.maxOccupancy,
                    }}
                    defaultMessage='{ maxOccupancy, plural, one {# person} other {# people}} max' />
                </li>
                <li>
                  <i className='font-icons room-icon' />
                  <FormattedMessage id='bed_type'
                    values={{
                      bedTypeTitle: room.bedTypeTitle,
                    }}
                    defaultMessage='{ bedTypeTitle } bed' />
                </li>
                <li>
                  <i className='font-icons length-icon' />
                  <FormattedMessage id='room_size'
                    values={{
                      roomSize: <ConvertMetersToFeets data={room.size} currentUnits={this.props.areaFormat} />,
                    }}
                    defaultMessage='{ roomSize } room size' />
                </li>
                { room.minAge ? (
                  <li>
                    <i className='font-icons icon-warning' />
                    <FormattedMessage id='min_age'
                      values={{
                        minAge: room.minAge,
                      }}
                      defaultMessage='Min age of guests: {minAge}' />
                  </li>
                ) : ''}
              </ul>
              <a className='room-more-info' onClick={() => this.props.openRoomPopup(room)}>
                <FormattedMessage id='show_room_info' defaultMessage='Show room information' />
                <i className='font-icons right-arrow-icon' />
              </a>
            </div>
          </div>
        </div>
        <div className='resort-pricing__whats-included'>
          <div className='included'>
            { roomParams.divers ? (
              <div className={`features mobile-collapse ${this.state.diversCollapse ? 'active' : ''}`}>
                <strong onClick={() => this.mobileCollapseHandler('diversCollapse')}>
                  <FormattedMessage id='diver_package' defaultMessage='Diver package' /> x {roomParams.divers}
                  <i className='bottom-arrow-icon font-icons' />
                </strong>
                <ul>
                  { !isFixedPackage ? (
                    <li>
                      <i className='font-icons icon-tick' />
                      <FormattedMessage id='pricing.dives_per_diver_with_kind'
                        values={{
                          divesAmount: room.divesAmount,
                          diveType,
                        }}
                        defaultMessage='{ divesAmount } { diveType } dives per diver' />
                      <div className='padi-label' data-tip={intl.formatMessage(messages.fullyFlexibleDescription)}>
                        <FormattedMessage id='fully_flexible' defaultMessage='Fully flexible' />
                        <i className='font-icons info-icon' />
                      </div>
                    </li>
                  ) : (
                    <Fragment>
                      {
                        room.packageDiveKind !== 30 ? (
                          <li data-tip={intl.formatMessage(messages.notFlexibleDives)}>
                            <i className='font-icons icon-tick' />
                            <FormattedMessage id='pricing.dives_per_diver'
                              values={{
                                divesAmount: room.divesAmount,
                              }}
                              defaultMessage='{ divesAmount } dives per diver' />
                          </li>
                        ) : ''
                      }
                      {
                        room.packageDiveKind === 20 || room.packageDiveKind === 30
                          ? (<li>
                            <i className='font-icons icon-tick' />
                            <FormattedMessage id='unlimited_shore_dives' defaultMessage='Unlimited shore dives' />
                          </li>) : ''
                      }
                    </Fragment>)
                  }
                  <li>
                    <i className='font-icons icon-tick' />
                    <FormattedMessage id='meals_as_chosen' defaultMessage='Meals as per chosen meal plan' />
                  </li>
                  {insurance &&
                  <li className='insurance diver-info-tooltip'>
                    <i className='font-icons icon-tick' />
                    <FormattedMessage id='free_insurance' defaultMessage='Free DAN dive accident insurance' />
                    <div className='padi-label' data-tip={insuranceTooltip}>
                      <FormattedMessage id='padi_exclusive' defaultMessage='PADI exclusive' />
                      <i className='font-icons info-icon' />
                    </div>
                  </li>
                  }
                  {
                    room.diveCenterInclusions.map(inclusion => {
                      return (<li className='insurance' key={inclusion.title}>
                        <i className='font-icons icon-tick' />
                        { inclusion.title }
                        {
                          inclusion.isPtExclusive ? (
                            <div className='padi-label'>
                              <FormattedMessage id='padi_exclusive' defaultMessage='PADI exclusive' />
                              <i className='font-icons info-icon' />
                            </div>
                          ) : ''
                        }
                      </li>)
                    })
                  }
                  {
                    !isFixedPackage && room.resortRoomInclusions.map(inclusion => {
                      return (<li className='insurance' key={inclusion.title}>
                        <i className='font-icons icon-tick' />
                        { inclusion.title }
                        {
                          inclusion.isPtExclusive ? (
                            <div className='padi-label'>
                              <FormattedMessage id='padi_exclusive' defaultMessage='PADI exclusive' />
                              <i className='font-icons info-icon' />
                            </div>
                          ) : ''
                        }
                      </li>)
                    })
                  }
                </ul>
              </div>
            ) : '' }
            { roomParams.students ? (<div className={`features mobile-collapse ${this.state.studentsCollapse ? 'active' : ''}`}>
              <strong onClick={() => this.mobileCollapseHandler('studentsCollapse')}>
                <FormattedMessage id='student_package' defaultMessage='Student package' /> x {roomParams.students}
                <i className='bottom-arrow-icon font-icons' />
              </strong>
              <ul>
                <li>
                  <i className='font-icons icon-tick' />
                  <FormattedMessage id='meals_as_chosen' defaultMessage='Meals as per chosen meal plan' />
                </li>
                {
                  room.studentInclusions.map(inclusion => {
                    return (<li className='insurance' key={inclusion.title}>
                      <i className='font-icons icon-tick' />
                      { inclusion.title }
                      {
                        inclusion.isPtExclusive ? (
                          <div className='padi-label'>
                            <FormattedMessage id='padi_exclusive' defaultMessage='PADI exclusive' />
                            <i className='font-icons info-icon' />
                          </div>
                        ) : ''
                      }
                      { inclusion.activity ? (
                        <Fragment>
                          <i className='font-icons info-icon'
                            onClick={() => this.props.setPopupData('isOpenInclusionDescriptionPopup', {
                              activity: inclusion.activity,
                              thumbnails: inclusion.thumbnails,
                              activityTitle: inclusion.title,
                            })} data-tip={intl.formatMessage(messages.courseTooltip)} />
                        </Fragment>) : '' }
                    </li>)
                  })
                }
                {insurance &&
                <li className='insurance diver-info-tooltip'>
                  <i className='font-icons icon-tick' />
                  <FormattedMessage id='free_insurance' defaultMessage='Free DAN dive accident insurance' />
                  <div className='padi-label' data-tip={insuranceTooltip}>
                    <FormattedMessage id='padi_exclusive' defaultMessage='PADI exclusive' />
                    <i className='font-icons info-icon' />
                  </div>
                </li>
                }
                {
                  !isFixedPackage && room.resortRoomInclusions.map(inclusion => {
                    return (<li className='insurance' key={inclusion.title}>
                      <i className='font-icons icon-tick' />
                      { inclusion.title }
                      {
                        inclusion.isPtExclusive ? (
                          <div className='padi-label'>
                            <FormattedMessage id='padi_exclusive' defaultMessage='PADI exclusive' />
                            <i className='font-icons info-icon' />
                          </div>
                        ) : ''
                      }
                    </li>)
                  })
                }
              </ul>
            </div>) : '' }
            { roomParams.nonDivers ? (<div className={`features mobile-collapse ${this.state.nonDiversCollapse ? 'active' : ''}`}>
              <strong onClick={() => this.mobileCollapseHandler('nonDiversCollapse')}>
                <FormattedMessage id='non-diver_package' defaultMessage='Non-diver package' /> x { roomParams.nonDivers }
                <i className='bottom-arrow-icon font-icons' />
              </strong>
              <ul>
                <li>
                  <i className='font-icons icon-tick' />
                  <FormattedMessage id='meals_as_chosen' defaultMessage='Meals as per chosen meal plan' />
                </li>
                {
                  room.resortRoomInclusions.map(inclusion => {
                    return (<li className='insurance' key={inclusion.title}>
                      <i className='font-icons icon-tick' />
                      { inclusion.title }
                      {
                        inclusion.isPtExclusive ? (
                          <div className='padi-label'>
                            <FormattedMessage id='padi_exclusive' defaultMessage='PADI exclusive' />
                            <i className='font-icons info-icon' />
                          </div>
                        ) : ''
                      }
                    </li>)
                  })
                }
              </ul>
            </div>) : '' }
            <p className='link-color' onClick={() => this.showWhatsIncluded(room, diveType)}>
              > <FormattedMessage id='full_details_whats_included' defaultMessage='Full details of what’s included and not' />
            </p>
          </div>
        </div>
        <div className='resort-pricing__meal-plan'>
          <div className='meal-plan-selector'>
            {
              // room.rates.length > 1 ?
              room.rates.map(rate => {
                return (
                  <div className='radio-wrap' key={rate.id}>
                    <label>
                      <input type='radio'
                        name={`mealplan${room.id}`}
                        value={rate.mealPlan}
                        checked={this.state.mealPlan === rate.mealPlan}
                        onChange={(e) => {
                          this.setState({
                            mealPlan: +e.target.value,
                          })
                        }} />
                      <span>
                        <i className={mealPlanIcon(rate.mealPlan)} />
                        { rate.mealPlan
                          ? getTextFromInfo(rate.mealPlan, 'shop', 'RESORT_MEAL_PLANS')
                          : (<FormattedMessage id='no_meals_included' defaultMessage='No meals included' />) }
                        { this.props.mealPlans && this.props.mealPlans[rate.mealPlan] ? (
                          <Fragment>
                            {this.state.isOpenMealPlanPopup}
                            <i className='font-icons info-icon' onClick={(e) => {
                              e.preventDefault()
                              this.props.setPopupData('isOpenMealPlanPopup', {
                                mealPlan: rate.mealPlan,
                                iconClass: mealPlanIcon(rate.mealPlan),
                                mealPlanDescription: this.props.mealPlans[rate.mealPlan],
                              })
                              return false
                            }} data-tip={intl.formatMessage(messages.tooltipMealplanInfo)} />
                          </Fragment>
                        ) : '' }
                        <i className='hint'>
                          { rate.ratePrice >= pricingObject.ratePrice ? '+' : ''}<PriceConverter amount={(rate.ratePrice - pricingObject.ratePrice) / totalGuests} currency={room.currency} />&nbsp;
                          <FormattedMessage id='per_person' defaultMessage='per person' />
                        </i>
                      </span>
                    </label>
                  </div>
                )
              })
              // : (<span>
              //   <i className={mealPlanIcon(room.rates[0].mealPlan)} />
              //   { room.rates[0].mealPlan
              //     ? getTextFromInfo(room.rates[0].mealPlan, 'shop', 'RESORT_MEAL_PLANS')
              //     : (<FormattedMessage id='no_meals_included' defaultMessage='No meals included' />) }
              // </span>)
            }
          </div>
        </div>
        <div className='resort-pricing__price'>
          <div className='pricing-wrapper'>
            {
              pricingObject.compareRatePrice > pricingObject.ratePrice
                ? (<div>
                  <PromotionLabel promotion={{ kind: 10 }} price={pricingObject.ratePrice} currency={room.currency} compareAtPrice={pricingObject.compareRatePrice} />
                </div>) : ''
            }
            <div className='price-per-guest-wrapper'>
              <strong className='price-per-guest'><PriceConverter amount={pricingObject.ratePrice / totalGuests} currency={room.currency} /></strong>
              {
                pricingObject.compareRatePrice > pricingObject.ratePrice ? (
                  <span className='old-price'><PriceConverter amount={pricingObject.compareRatePrice / totalGuests} currency={room.currency} /></span>
                ) : ''
              }
              { totalGuests > 1 ? (
                <p className='price-per-guest__text'>
                  <FormattedMessage id='avg_per_person'
                    values={{
                      duration: room.nights,
                    }}
                    defaultMessage='Avg. per person for { duration, plural, one {# night} other {# nights}}' />
                </p>
              ) : '' }
            </div>
            <div className='total-price-wrapper'>
              { totalGuests > 1 ? (
                <Fragment>
                  <strong className='total-price'><PriceConverter amount={pricingObject.ratePrice} currency={room.currency} /></strong>
                  {
                    pricingObject.compareRatePrice > pricingObject.ratePrice ? (
                      <span className='old-price'><PriceConverter amount={pricingObject.compareRatePrice} currency={room.currency} /></span>
                    ) : ''
                  }
                </Fragment>) : ''
              }
              <p className='total-price__text'>{ generateGuestsText(roomParams, true) }, { generatePricingType(isFixedPackage, roomParams, room) }</p>
            </div>
            <a href={this.checkoutDrUrl(pricingObject, room)} className='btn-red'>
              <FormattedMessage id='customize_package' defaultMessage='Customize Package' />
            </a>
          </div>
          { !isLastMinuteBooking(get(this.props.filters, 'date_0')) &&
          (<p className='benefit'>
            <i className='font-icons ok-icon-new' />
            <FormattedMessage id='48h_free_cancellation' defaultMessage='48h free cancellation period' />
          </p>)
          }
          <p className='price-explanation'><FormattedMessage id='prices_included_taxes' defaultMessage='Prices include taxes & service fees' /></p>
        </div>
      </div>
    )
  }
}

ResortPricingRow.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(connect()(ResortPricingRow))
